/**
 * @title carousel.hero.js: Sub-module of Browse feature
 * @description This module expresses any custom behavior
 * associated with the carousels.
 * @dependency utility.js
 */
define([], function() {

  return {
    /**
     * The initializing function modules use
     * to call.
     * @return {[type]} [description]
     */
    init : function() {
	  COSTCO.util.safe(this.createHeroCarousel).call(this);
      COSTCO.util.safe(this.createFeatureTileCarousel).call(this);
      COSTCO.util.safe(this.createFeatureCarousel).call(this);
      COSTCO.util.safe(this.bind_resize).call(this);
    },
    /**
     * [bind_resize description]
     * @return {[type]} [description]
     */
    bind_resize : function() {
    	$(window).unbind('resize.carousel').on('resize.carousel', 
    		COSTCO.util.debounce(function() {
		        if (window.innerWidth <= 668) {
		        	this.createFeatureTileCarousel(); 
		        }
		        this.createHeroCarousel();
		    }, 250).bind(this)
		);
	},
	getFeatureCarouselOptions: function(breakpoint) {
		//Default desktop value 
		var slideValue = COSTCO.util.isBDStore() ? 6 : 5;
		return {
			dots: true,
			arrows: true,
			infinite: false,
			slidesToShow: slideValue,
			slidesToScroll: slideValue,
			autoplay: false,
			lazyLoad: 'ondemand',
			owlDotLabel: messages.FEATURE_CAROUSEL_OWL_DOT_LABEL,
			responsive : [{
				breakpoint: breakpoint,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2,
					dots: true,
					infinite: false,
					arrows: false
				}
			}]
		  };
	},
    /**
     * [createFeatureCarousel description]
     * @return {[type]} [description]
     */
    createFeatureCarousel : function () {
		var _this = this
        $('.feature-carousel').on('init', function(event, slick){
        	COSTCO.myLocation.initRegionFees();
        });
        $('.advanced-feature-carousel').on('init', function(event, slick){       	
        	  COSTCO.myLocation.initRegionFees();
        });
		function callback(entries, observer) {
			entries.forEach(entry => {
				if(!entry.target.classList.contains('slick-initialized')) {
					COSTCO.util.carousel(entry.target, _this.getFeatureCarouselOptions(667), {nextLabel: messages.FEATURE_CAROUSEL_NEXT, prevLabel: messages.FEATURE_CAROUSEL_PREVIOUS});
					observer.unobserve(entry.target);
				}
			});
		};

		let observer = new IntersectionObserver(callback, options = {
			root: null,
			rootMargin: '0px 0px 200px 0px',
			threshold: 0
		});

		document.querySelectorAll('.feature-carousel').forEach(function(item) {
			observer.observe(item);
		});

		$(document).ready(function(e){
    		//Start Grocery Changes
    	 	if (!$('.advanced-feature-carousel').hasClass('slick-initialized')) {	
			  	COSTCO.util.carousel('.advanced-feature-carousel', _this.getFeatureCarouselOptions(769), {nextLabel: messages.FEATURE_CAROUSEL_NEXT, prevLabel: messages.FEATURE_CAROUSEL_PREVIOUS});
    	    }
    	});    	
    	//End Grocery Changes
    	//loop  running through .slick-slide instances is removed as the variable descriptionId 
    	//declared inside the callback function is not being used.
    },

    /**
     * [createFeatureTileCarousel description]
     * @return {[type]} [description]
     */
    createFeatureTileCarousel : function () {
    	//Code to hide the title for the carousel if there are no products to display.
    	let carouselElem = $('.feature-carousel-container');
    	$.each(carouselElem,function (index, value) {
    		if($(value).find('.product-tile-set').length<1 && $(value).find('.hl-product').length<1){
    			$(value).find('h2').addClass('hide');
			}
		});
      if(!$('.feature-tiles').hasClass('slick-initialized')){
    	  // Function need to be fired to remove slick ADA stuff
	      $('.feature-tiles').on('destroy', function(event, slick){
	      	console.log("destroyed featureTileCarousel");
	      	$('.feature-tiles').find('a, input, button, select').removeAttr('tabindex');
	      	$('.feature-tiles').find('div').removeAttr('tabindex aria-hidden');
	      });
	      if ($(window).width() <= 667) {
	    	  COSTCO.util.carousel('.feature-tiles', {
				  mobileFirst:true,
				  dots: true,
				  arrows: false,
				  slidesToShow: 2,
				  slidesToScroll: 2,
				  responsive : [{
					  breakpoint: 667,
					  settings: 'unslick'
				  }]
			  });
	      }
	  }
    },
    
    /**
     * [createHeroCarousel description]
     * Content can be randomized before the carousel initializes
     * Business will need to add the variable randomizeHeroCarousel=true to eSpot footer;
     * @return {[type]} [description]
     */
    createHeroCarousel : function() {
    	
    	//Will randomize hero content
    	$.fn.randomizeHero = function(selector){
    		var $elems = selector ? $(this).find(selector) : $(this).children(),$parents = $elems.parent();

    		$parents.each(function(){
    			$(this).children(selector).sort(function(){
    		          return Math.round(Math.random()) - 0.5;
    		      }).detach().appendTo(this);
    		});
    		return this;
    	};

    	//Will check if content should be randomized
    	if(typeof(randomizeHeroCarousel) !== "undefined"){
    		if (randomizeHeroCarousel==true){
    			$('#hero-carousel').randomizeHero('a')
    		}
			window.randomizeHeroCarousel = "done";
    	}
    	
    	var $carouselDiv = $('#hero-carousel');
    	var defaultBreakpoint = 'TABLET-LANDSCAPE';
    	if(typeof(heroBreakpoint) !== "undefined"){
    		defaultBreakpoint = heroBreakpoint;
    	}
    	
    	if (!$carouselDiv.hasClass('slick-initialized')) {
    		var options = {
		        dots: true,
		        infinite: true,
		        arrows: true,
		        autoplay: true,
		        autoplaySpeed: 8000,
		        pauseOnHover : true,
		        lazyLoad: 'progressive',
		        owlDotLabel: messages.HERO_CAROUSEL_OWL_DOT_LABEL
    	    }
    		$carouselDiv.on('init', function() {
    			$('img:hidden', $carouselDiv).show();
    		});
    		COSTCO.util.carousel($carouselDiv, options, {hasPause: true, nextLabel: messages.HERO_CAROUSEL_NEXT, prevLabel: messages.HERO_CAROUSEL_PREVIOUS});
    	}
    	
    	if ($('#isLozadLazyEnabled').val() == "true") {
    	    const imgResponsiveEle=document.querySelectorAll('#hero-carousel .slick-cloned img[data-src].img-responsive');
    	    const lozadObserver = lozad(imgResponsiveEle);
    	    lozadObserver.observe();
    	}else {
    		$('#hero-carousel .slick-cloned img').unveil(400);
    	}
    }
  }
});



// WEBPACK FOOTER //
// ./js/browse/carousel.js